var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBackIconGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.861 19.655a1.284 1.284 0 01-1.699.047l-.117-.111-6.46-6.907a1.285 1.285 0 01-.087-1.652l.1-.118 6.461-6.682a1.285 1.285 0 011.953 1.663l-.1.123-5.61 5.807 5.62 6.014a1.284 1.284 0 01.046 1.699l-.107.117z",
  fill: "#999"
})));
export default __webpack_public_path__ + "static/back-icon-grey.5d5bfb31c99ffa058c30db63b9e1a962.svg";
export { SvgBackIconGrey as ReactComponent };